import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContactUsService } from '../../../section/user/service/contact-us.service';
import { SharedService } from '../../../component/shared/shared.service';
import { Subscription } from '../model/contact-us';

@Component({
  selector: 'app-subscription-invoice',
  templateUrl: './subscription-invoice.component.html',
  styleUrls: ['./subscription-invoice.component.css']
})
export class SubscriptionInvoiceComponent implements OnInit {

  userService : ContactUsService; 
  subscription: any = [];
 
  constructor(private _sharedService: SharedService,private _UserService: ContactUsService,private route: ActivatedRoute) {
     
 
   }
  ngOnInit() {
 
    this.route.params.subscribe(params => {     
      let id: any = +params['id'];    
      this.getInvoiceForOrderId(id);
   });
   
  }
   
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
 
  getInvoiceForOrderId(id: string) : void {
     
     this._UserService.getInvoiceForOrderId(id).subscribe(data=>{
       
        this.subscription = data;
       
         
     },error=>{

     });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/section/user/subscription-invoice/subscription-invoice.component.ts